/**
 * @typedef {InstanceType<ReturnType<typeof import('widgets/forms/BasicInput').default>>} basicInput
 */

/**
 * @description PaymentAccordionItem implementation
 * @param {ReturnType<typeof import('widgets/global/AccordionItem').default>} AccordionItem widget
 * @returns {typeof PaymentAccordionItem} Payment Tab Panel class
 */
export default function (AccordionItem) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class PaymentAccordionItem
     * @augments AccordionItem
     * @classdesc Payment Accordion Item general behaviour.
     * <br> Uses as a parent of the children payment widget. For example {@link PaymentAccordionItemCREDITCARD}
     * <br> Has next features:
     * 1. Opens active payment panel on page load\widget reload
     * 2. General payment processing handler
     * 3. General error handling of the current payment accordion item
     * 4. General validation of the current payment accordion item
     *
     * Widget should be not used as standalone widget, it should be mixed to other widgets (see {@tutorial WidgetsMixinsStrategy})
     *
     * @property {boolean} data-expanded - Expanded flag
     * @property {string} data-method-name - payment method name
     */
    class PaymentAccordionItem extends AccordionItem {
        /**
         * @description Initialize widget logic
         * @returns {void}
         */
        init() {
            super.init();

            if (this.prefs().expanded) {
                this.openPanel();
            }
        }

        /**
         * @description Handles payment tab submit.
         * Each payment should implement its own "process" method
         * @returns {Promise} result
         */
        process() {
            return new Promise((resolve, reject) => {
                reject(new Error('No payment'));
            });
        }

        /**
         * @description Handle panel errors
         * @param {object} data - data jobject
         * @returns {void}
         */
        handleError(data) {
            if (!data.fieldName) {
                return;
            }

            this.getById(data.fieldName, (/** @type {basicInput} */field) => {
                if (field.id === data.fieldName) {
                    field.setError(data.errorMsg);
                }
            });
        }

        /**
         * @description Validate child elements.
         * Each payment should implement its own "isChildrenValid" method
         *
         * @returns {boolean} result
         */
        isChildrenValid() {
            return false;
        }

        /**
         * @description On widget Refresh Handler
         * @returns {void}
         */
        onRefresh() {
            super.onRefresh();

            if (this.isPanelOpen) {
                this.openPanel();
            }
        }

        /**
         * @description Opens payment accordion panel
         * @emits AccordionItem#closeallitems
         * @emits "checkout.paymentmethod.changed"
         * @returns {void}
         */
        openPanel() {
            super.openPanel();

            if (this.isPanelOpen) {
                this.eventBus().emit('checkout.paymentmethod.changed', {
                    methodName: this.prefs().methodName,
                    methodId: this.prefs().methodId
                });
            }

            // Todo : temporary fix to disable review order for apple pay.
            if (this.prefs().methodId === 'DW_APPLE_PAY') {
                $('.m-billing .b-checkout_step-controls button').prop("disabled", true);
            } else {
                $('.m-billing .b-checkout_step-controls button').prop("disabled", false);
            }

            this.data('expanded', 'true');
            this.data('selected', 'true');
        }

        closePanel() {
            super.closePanel();
            this.data('expanded', 'false');
            this.data('selected', 'false');
        }

        /**
         * @description Clears sensetive data
         * @returns {void}
         */
        cleanupSensitiveData() {
        }
    }

    return PaymentAccordionItem;
}
